const ONE_HOUR = 60 * 60 * 1000;
export const DEFAULT_REFERENTIALS_STALE_TIME = ONE_HOUR;
export const REFERENTIALS_API_URL = "/referential";
